import { c as _c } from "react/compiler-runtime";
import type { ReviewCreditCardsPage } from '@cc-shopping/contracts/credit-cards-page/reviews/schema/types';
import { CdnImage, IMAGE_SIZES } from '@cc-shopping/ui/primitives/CdnImage';
import customImageWidthURLBuilder from '@cc-shopping/utils/custom-image-width-url-builder';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
import { useAlternatePickClickAnalytics } from '../../hooks';
type AlternatePickImageCtaProps = {
  ctaAnalytics: NonNullable<ReviewCreditCardsPage['alternatePicks'][number]['marketplaceEntity']>['ctaAnalytics'];
  reviewLink: string;
  image: NonNullable<ReviewCreditCardsPage['alternatePicks'][number]['marketplaceEntity']>['image'];
  parentActivityId: string;
};
export default function AlternatePickImageCta(t0) {
  const $ = _c(15);
  const {
    ctaAnalytics,
    reviewLink,
    image,
    parentActivityId
  } = t0;
  const {
    resizable: resizableImage,
    medium: mediumImage
  } = image;
  let t1;
  if ($[0] !== mediumImage.url || $[1] !== mediumImage.width || $[2] !== resizableImage) {
    t1 = customImageWidthURLBuilder(resizableImage, {
      customImageWidth: mediumImage.width,
      customImageQuality: 100,
      imageParentWidth: 160
    }, mediumImage.url);
    $[0] = mediumImage.url;
    $[1] = mediumImage.width;
    $[2] = resizableImage;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    optimized
  } = t1;
  const {
    fireClickPageAction
  } = useAlternatePickClickAnalytics("product_image", parentActivityId);
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      objectFit: "contain",
      objectPosition: "center"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== optimized.image.url) {
    t4 = <CdnImage alt="alternate-pick-product-card-image" src={optimized.image.url} fill={true} style={t3} sizes={IMAGE_SIZES.MINI_PRODUCT_CARD} />;
    $[6] = optimized.image.url;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== ctaAnalytics || $[9] !== fireClickPageAction || $[10] !== optimized.parentElement.height || $[11] !== optimized.parentElement.width || $[12] !== reviewLink || $[13] !== t4) {
    t5 = <CtaLink analytics={ctaAnalytics} type="PRODUCT_IMAGE" href={reviewLink} flex={1} position="relative" minHeight="100px" maxHeight="125px" height={optimized.parentElement.height} width={optimized.parentElement.width} parameterActions={t2} skipShoppingFinishedEvent={true} isReview={true} onClickAnalyticsCallback={fireClickPageAction}>{t4}</CtaLink>;
    $[8] = ctaAnalytics;
    $[9] = fireClickPageAction;
    $[10] = optimized.parentElement.height;
    $[11] = optimized.parentElement.width;
    $[12] = reviewLink;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
}